var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMissionsTranslation } from '../../../../ui/hooks';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, styled, Tooltip, tooltipClasses, Typography } from '@mui/material';
import React from 'react';
import { useShiftPositionDetails } from '../../shift/hooks/useShiftPositionDetails';
export const PositionDetailsTooltip = ({ shiftId, positionId }) => {
    const { t } = useMissionsTranslation();
    const [open, setOpen] = React.useState(false);
    const [loadTooltipData, setLoadTooltipData] = React.useState(false);
    const { shiftPositionDetails: tooltipData, isLoading } = useShiftPositionDetails({
        shiftId,
        positionId,
        loadData: loadTooltipData,
    });
    const handleMouseEnter = () => {
        if (!loadTooltipData) {
            setLoadTooltipData(true);
        }
        setOpen(true);
    };
    const handleMouseLeave = () => {
        setOpen(false);
    };
    const positionPropertiesOrder = [
        'occupationGroup',
        'occupations',
        'ecls',
        'skills',
        'trainings',
        'languages',
        'state',
        'counties',
        'tribes',
        'deploymentDuration',
        'deploymentTravelWillingness',
        'federalDeploymentWillingness',
        'priorCommitments',
    ];
    const tooltipContent = !isLoading && tooltipData ? (React.createElement(Box, { sx: { display: 'flex', gap: 1, flexDirection: 'column' } }, positionPropertiesOrder
        .filter((key) => !!tooltipData[key])
        .map((key) => (React.createElement(Typography, { fontSize: 'small', key: `${positionId}_${key}` },
        React.createElement("strong", null, t(`shifts.positionDetails.keys.${key}`)),
        ":",
        React.createElement(Box, { component: 'span', sx: { ml: 1 } }, tooltipData[key])))))) : (React.createElement(Typography, null, t('common.loading')));
    const MaxHeightScrollableTooltip = styled((_a) => {
        var { children, className } = _a, props = __rest(_a, ["children", "className"]);
        return (React.createElement(Tooltip, Object.assign({}, props, { classes: { popper: className } }), children));
    })({
        [`& .${tooltipClasses.tooltip}`]: {
            maxHeight: '200px',
            overflowY: 'auto',
        },
    });
    return (React.createElement(MaxHeightScrollableTooltip, { enterTouchDelay: 0, title: tooltipContent, onOpen: handleMouseEnter, onClose: handleMouseLeave, open: open, placement: 'bottom-start', "data-test": 'position-tooltip' },
        React.createElement(InfoOutlinedIcon, { sx: { position: 'absolute', ml: 1 }, fontSize: 'small', color: 'primary', "aria-label": t('shifts.positionDetails.ariaLabels.infoIcon') })));
};
